import { DevelopmentSection } from 'constants/DevelopmentConstants'

interface WorkstreamSectionProps {
  section: DevelopmentSection
}

export const WorkstreamSection = ({ section }: WorkstreamSectionProps) => (
  <div className="flex flex-col gap-4 items-start w-full">
    <p className="subtitle-xl text-center w-full">{section.title}</p>
    <div className="dev-divider" />
    <div className="flex gap-2 items-start w-full">
      {section.cards.map(card => (
        <div key={card.title} className={`dev-card dev-card-${section.variant}`}>
          <p className="subtitle-xs dev-card-title">{card.title}</p>
          <div className="dev-card-thumb">
            <img src={card.image} alt={card.title} />
          </div>
        </div>
      ))}
    </div>
  </div>
)
